import * as React from 'react';
import { observer } from 'mobx-react';
import { Panel, TabsPanel } from '@ixicare/ui';
import { usePageTitle } from '~components/DashboardWrapper/PageTitle';
import { t } from '~/i18n';
import { useStores } from '~store/utils';
import ErrorPage from '~/pages/ErrorPage';
import { AlertsTab } from './AlertsTab';
import { BillingTab } from './BillingTab';

const StatisticsPage: React.FC = observer(() => {
  const { permissions } = useStores();
  usePageTitle(t('menu.dashboard.statistics'));

  // Each tab is gated by its own permission, so a tab's queries never run for someone who may not see it.
  const tabs = [
    permissions.has('can_view_billing') && {
      id: 'active',
      label: t('statistics.tabs.active'),
      content: <BillingTab />,
    },
    permissions.has('can_view_analytics') && {
      id: 'alerts',
      label: t('menu.dashboard.alerts'),
      content: <AlertsTab />,
    },
  ].filter((tab) => !!tab);

  if (tabs.length === 0) {
    return <ErrorPage statusCode={404} />;
  }

  return (
    <Panel>
      <TabsPanel useHash tabs={tabs} />
    </Panel>
  );
});

export default StatisticsPage;
